import { render } from "./TheMyCollectionItemListView.vue?vue&type=template&id=9fd43ca6&scoped=true&ts=true"
import script from "./TheMyCollectionItemListView.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionItemListView.vue?vue&type=script&lang=ts"

import "./TheMyCollectionItemListView.vue?vue&type=style&index=0&id=9fd43ca6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fd43ca6"]])

export default __exports__